import { IconProps } from "../../types/icon";

export default function MuteIcon({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1416_9671)">
        <path
          d="M19.9066 18.6155H13.7378C12.7345 18.6155 11.9199 19.4301 11.9199 20.4334V29.9995C11.9199 31.0028 12.7345 31.8173 13.7378 31.8173H19.9066L27.8734 38.7908C28.668 39.4861 29.8998 38.9199 29.8998 37.8669V12.5659C29.8998 11.513 28.6581 10.9567 27.8734 11.6421L19.9066 18.6155Z"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M32.4043 29.7017C34.0334 29.066 35.2056 27.4865 35.2056 25.6289C35.2056 23.7714 34.0334 22.1919 32.4043 21.5562"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M34.0137 33.7048C37.252 32.4433 39.5765 29.3042 39.5765 25.6288C39.5765 21.9533 37.252 18.8143 34.0137 17.5527"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M25.2209 49.9463C38.8761 49.9463 49.9458 38.8766 49.9458 25.2214C49.9458 11.5663 38.8761 0.496582 25.2209 0.496582C11.5658 0.496582 0.496094 11.5663 0.496094 25.2214C0.496094 38.8766 11.5658 49.9463 25.2209 49.9463Z"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M39 10.4331L10 39.4331"
          stroke={color}
          strokeLinecap="round"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1416_9671">
          <rect width="50.4331" height="50.4331" fill={color}></rect>
        </clipPath>
      </defs>
    </svg>
  );
}
